export const PLAN_TYPE_DATA = [
  { name: "Medicaid", value: "FD" },
  { name: "State", value: "ST" },
  { name: "Commercial", value: "COMM" },
  { name: "Supplemental", value: "SUPP" },
];
